(() => {
  if (window.__auroraCardMediaReady) return;
  window.__auroraCardMediaReady = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const root = document.getElementById('MainContent');
  if (!root) return;
  const selector = '.aurora-product-card__media,.aurora-product__catalog-card-media,.aurora-cart-rec-card__media,.aurora-arrivals-26__media,.aurora-list-product-card__image';
  const prepared = new WeakSet();
  const prepare = media => {
    const image = media.querySelectorAll('img')[1];
    if (!image || prepared.has(image)) return;
    prepared.add(image);
    image.loading = 'eager';
    image.decoding = 'async';
    if (image.decode) image.decode().catch(() => {});
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          prepare(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '200px', threshold: 0 })
    : null;
  const scan = scope => {
    const media = [];
    if (scope.matches?.(selector)) media.push(scope);
    scope.querySelectorAll(selector).forEach(element => media.push(element));
    media.forEach(element => {
      if (observer) observer.observe(element);
      else prepare(element);
    });
  };
  scan(root);
  root.addEventListener('pointerover', event => {
    const media = event.target.closest?.(selector);
    if (media) prepare(media);
  }, { passive: true });
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      event.target.querySelectorAll(selector).forEach(element => observer?.unobserve(element));
    });
  }
})();

(() => {
  if (new URL(location.href).searchParams.get('aurora_perf') !== '1') return;
  let lcp = 0, cls = 0;
  const tasks = [];
  const observers = [];
  for (const [type, collect] of [
    ['largest-contentful-paint', entries => entries.forEach(e => { lcp = e.startTime; })],
    ['layout-shift', entries => entries.forEach(e => { if (!e.hadRecentInput) cls += e.value; })],
    ['longtask', entries => entries.forEach(e => tasks.push(e.duration))]
  ]) {
    try {
      const observer = new PerformanceObserver(list => collect(list.getEntries()));
      observer.observe({type, buffered:true});
      observers.push(observer);
    } catch (_) {}
  }
  const report = () => setTimeout(() => {
    const nav = performance.getEntriesByType('navigation')[0];
    const resources = performance.getEntriesByType('resource');
    console.info('AURORA_PERF ' + JSON.stringify({
      path: location.pathname,
      ttfb_ms: Math.round(nav.responseStart - nav.startTime),
      dom_ms: Math.round(nav.domContentLoadedEventEnd),
      load_ms: Math.round(nav.loadEventEnd),
      lcp_ms: Math.round(lcp),
      cls: Number(cls.toFixed(4)),
      long_tasks: tasks.length,
      total_blocking_ms: Math.round(tasks.reduce((sum, duration) => sum + Math.max(0, duration-50),0)),
      requests: resources.length,
      known_transfer_kb: Math.round(resources.reduce((sum, e) => sum + e.transferSize,0)/1024),
      slow_resources: resources.sort((a,b) => b.duration-a.duration).slice(0,8).map(e => ({
        url: e.name.split('?')[0], ms:Math.round(e.duration), kb:Math.round(e.transferSize/1024), type:e.initiatorType
      }))
    }));
    observers.forEach(o => o.disconnect());
  }, 5000);
  if (document.readyState === 'complete') report();
  else window.addEventListener('load', report, {once:true});
})();
